import styled from 'styled-components';

// Anchors to the nearest positioned ancestor (the inbox list container / side panel).
const CreateFab = styled.button`
  position: absolute;
  bottom: 16px;
  right: 16px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: none;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 8px ${({ theme }) => theme.colors.black}33;
  z-index: 2;

  &:hover {
    opacity: 0.9;
  }
`;

export default CreateFab;
